import GentlyLogo from '@assets/ge_logo.png';

export const TREMENDOUS_HOVER = "You'll receive your payout in a virtual Visa gift card, which can be used to make purchases wherever Visa is accepted.";
export const SHIPPING_FEE_HOVER = 'Pro-rated amount of original shipping fee based on selected item value vs total order value.';
export const SERVICE_FEE_HOVER = 'Pro-rated amount of service fee based on selected item value vs total order value.';

/** 理赔类型 */
export const ClaimType = {
  Init: '',
  Damage: 'damage',
  Delay: 'delay',
  Theft: 'theft',
  Loss: 'loss',
  RA: 'return',
  EW: 'extended_warranty',
  AD: 'accidental_damage',
};

export const ClaimTypeText = {
  [ClaimType.Delay]: 'My package was delayed',
  [ClaimType.Damage]: 'My item(s) was damaged',
  [ClaimType.Loss]: 'My item(s) was lost in transit',
  [ClaimType.RA]: 'I want to return the item(s)',
  [ClaimType.Theft]: 'My package was stolen',
  [ClaimType.EW]: 'Electrical or mechanical failure',
  [ClaimType.AD]: 'Accidental damage from handling',
};
// 得物特有的merchantID映射  9111-test  2359-prod
export const PoizonMerchantID = ['2022122820353595329111', '2023051720232799322359'];

export const SHOPLINE = 'shopline';
/* **************************************************************新平台config start ***************************************************************************** */
// platform name 后续新增平台只需要在这里配置
export const PLATFORM_NAME = {
  TREET: 'treet',
  GARMENTORY: 'garmentory',
  POIZON: 'poizon',
  GENTLY: 'gently',
  DHGATE: 'dhlink',
  DIANXIAOMI: 'dianxiaomi',
  SHOPLAZZA: 'shoplazza',
  SIDELINESWAP: 'sidelineswap',
  SHOPPREMIUMOUTLETS: 'shoppremiumoutlets',
  GOODWILLFINDS: 'goodwillfinds',
  CURTSY: 'curtsy',
  SHOPSHOPS: 'shopshops',
  CTBIDS: 'ctbids',
  COMMENTSOLD: 'commentsold',
  LDJ: 'luxedujour',
  SEZZLE: 'sezzle',
  PP: 'parcelpanel',
  BAZO: 'bazo',
  NEWSPO: 'shopsimon',
  backcountry: 'backcountry',
  competitivecyclist: 'competitivecyclist',
  steepandcheap: 'steepandcheap',
  onekingslane: 'onekingslane',
  motosports: 'motosport',
  levelninesports: 'levelninesports',
  fehaute: 'fehaute',
  stylewe: 'stylewe',
  hardaddy: 'hardaddy',
  justfashionnow: 'justfashionnow',
  noracora: 'noracora',
  zolucky: 'zolucky',
  loop: 'loop',
  jeulia: 'jeulia',
  ruelala: 'ruelala',
  gilt: 'gilt',
  sifubuy: 'sifubuy',
  royaura: 'royaura',
  zeelool: 'zeelool',
  vooglam: 'vooglam',
  // huion: 'huion',
  dressin: 'dressin',
  // costway: 'costway',
};
export const dhgate = 'dhgate';
const {
  TREET, GARMENTORY, GENTLY, DHGATE, DIANXIAOMI, SHOPLAZZA, SIDELINESWAP, SHOPPREMIUMOUTLETS, GOODWILLFINDS, CURTSY, SHOPSHOPS, POIZON, CTBIDS, COMMENTSOLD, LDJ, SEZZLE, PP, BAZO, NEWSPO, backcountry, onekingslane, competitivecyclist,
  steepandcheap, motosports, fehaute, stylewe, hardaddy, justfashionnow, noracora, zolucky, loop, jeulia, ruelala, sifubuy, royaura, gilt,
  zeelool,
  vooglam,
  // huion,
  dressin,
  // costway,
  levelninesports,
} = PLATFORM_NAME;

export const COBRANDING_LOGO = {
  [GENTLY]: GentlyLogo,
  [SIDELINESWAP]: 'https://cdn.seel.com/assets/images/cobranding_sls.png',
  [SHOPPREMIUMOUTLETS]: 'https://cdn.seel.com/assets/images/cobranding_spo.png',
  [NEWSPO]: 'https://cdn.seel.com/assets/images/cobranding_spo.png',
  [GOODWILLFINDS]: 'https://cdn.seel.com/assets/images/cobranding_gwf.png',
  dhgate: 'https://cdn.seel.com/assets/images/cobranding_dhgate.png',
  [CURTSY]: 'https://cdn.seel.com/assets/images/cobranding_curtsy.png',
  [SHOPSHOPS]: 'https://cdn.seel.com/assets/images/co-branding_shopshops.png',
  [POIZON]: 'https://cdn.seel.com/assets/images/cobranding_poizon.png',
  [CTBIDS]: 'https://cdn.seel.com/assets/images/cobranding_ctbids.png',
  [COMMENTSOLD]: 'https://cdn.seel.com/assets/images/cobranding_commentsold.png',
  [LDJ]: 'https://cdn.seel.com/assets/images/cobranding_ldj.png',
  [backcountry]: 'https://cdn.seel.com/assets/images/cobranding_backcountry.png',
  [competitivecyclist]: 'https://cdn.seel.com/assets/images/cobranding_competitivecyclist.png',
  [steepandcheap]: 'https://cdn.seel.com/assets/images/cobranding_steepandcheap.png',
  [motosports]: 'https://cdn.seel.com/assets/images/cobranding_motosports.png',
  [levelninesports]: 'https://cdn.seel.com/assets/images/cobranding_levelninesports.png',
  [onekingslane]: 'https://cdn.seel.com/assets/images/cobranding_onekingslane.png',
  // [SEZZLE]: 'https://cdn.seel.com/assets/images/cobranding_sezzle.png',
  // [PP]: 'https://cdn.seel.com/assets/images/cobranding_pp.png',
  [BAZO]: 'https://cdn.seel.com/assets/images/cobranding_bazo.png',
  [fehaute]: 'https://cdn.seel.com/assets/images/cobranding_fehaute.png',
  [stylewe]: 'https://cdn.seel.com/assets/images/cobranding_stylewe.png',
  [hardaddy]: 'https://cdn.seel.com/assets/images/cobranding_hardaddy.png',
  [justfashionnow]: 'https://cdn.seel.com/assets/images/cobranding_justfashionnow.png',
  [noracora]: 'https://cdn.seel.com/assets/images/cobranding_noracora.png',
  [zolucky]: 'https://cdn.seel.com/assets/images/cobranding_zolucky.png',

  [jeulia]: 'https://cdn.seel.com/assets/images/cobranding_jeulia.png',
  [ruelala]: 'https://cdn.seel.com/assets/images/cobranding_ruelala.png',
  [gilt]: 'https://cdn.seel.com/assets/images/cobranding_gilt.png',
  [sifubuy]: 'https://cdn.seel.com/assets/images/cobranding_sifubuy.png',
  [royaura]: 'https://cdn.seel.com/assets/images/cobranding_royaura.png',
  [zeelool]: 'https://cdn.seel.com/assets/images/cobranding_zeelool.png',
  [vooglam]: 'https://cdn.seel.com/assets/images/cobranding_vooglam.png',
  // [huion]: 'https://cdn.seel.com/assets/images/cobranding_huion.png',
  [dressin]: 'https://cdn.seel.com/assets/images/cobranding_dressin.png',
  // [costway]: 'https://cdn.seel.com/assets/images/cobranding_costway.png',
};
// store 只存储platform 根据接口返回的policyType转换  后续可直接添加
export const policyTypeToPlatformMap = {
  GENTLY_RA: GENTLY,
  TREET_RA: TREET,
  GARMENTORY_BP: GARMENTORY,
  GARMENTORY_RA: GARMENTORY,
  dhgate_bp: DHGATE,
  // SHOPIFY_BP: 'poizon',
  shoplazza_bp: SHOPLAZZA,
  SHOPLAZZA_BP: SHOPLAZZA,
  SIDELINESWAP_RA: SIDELINESWAP,
  GOODWILLFINDS_RA: GOODWILLFINDS,
  'GOODWILLFINDS-GSP': GOODWILLFINDS,
  'GOODWILLFINDS-WFP': GOODWILLFINDS,
  SHOPPREMIUMOUTLETS_RA: NEWSPO,
  'SHOPPREMIUMOUTLETS-GSP': NEWSPO,
  'CURTSY-RA': CURTSY,
  'CURTSY-GSP': CURTSY,
  'SHOPSHOPS-RA': SHOPSHOPS,
  'SHOPSHOPS-GSP': SHOPSHOPS,
  'POIZON-GSP': POIZON,
  'CTBIDS-RA': CTBIDS,
  'CTBIDS-GSP': CTBIDS,
  'COMMENTSOLD-GSP': COMMENTSOLD,
  'LDJ-RA': LDJ,
  'LDJ-GSP': LDJ,
  'SEZZLE_SHOPIFY-GSP': SEZZLE,
  'PARCELPANEL_SHOPIFY-GSP': PP,
  'BAZO_SHOPIFY-WFP': BAZO,
  'backcountry-wfp': backcountry,
  'onekingslane-wfp': onekingslane,
};
// 用于登录入参 根据platform作映射 如果直接用platform的话，也许后期会存在不一致的情况 后续新增平台后，需要在这里配置
export const channelMap = {
  // [GARMENTORY]: GARMENTORY,
  // [GENTLY]: GENTLY,
  // [TREET]: TREET,
  [DHGATE]: dhgate,
  [DIANXIAOMI]: DIANXIAOMI,
  [SHOPLAZZA]: SHOPLAZZA,
  [SIDELINESWAP]: SIDELINESWAP,
  [SHOPPREMIUMOUTLETS]: SHOPPREMIUMOUTLETS,
  [GOODWILLFINDS]: GOODWILLFINDS,
  [CURTSY]: CURTSY,
  [SHOPSHOPS]: SHOPSHOPS,
  [POIZON]: POIZON,
  [CTBIDS]: CTBIDS,
  [COMMENTSOLD]: COMMENTSOLD,
  [LDJ]: 'ldj',
  [SEZZLE]: SEZZLE,
  [PP]: PP,
  [BAZO]: BAZO,
  [NEWSPO]: SHOPPREMIUMOUTLETS,
  [backcountry]: backcountry,
  [competitivecyclist]: backcountry,
  [steepandcheap]: backcountry,
  [motosports]: backcountry,
  [levelninesports]: backcountry,
  [onekingslane]: onekingslane,
  [stylewe]: 'chicv',
  [fehaute]: 'chicv',
  [hardaddy]: 'chicv',
  [justfashionnow]: 'chicv',
  [noracora]: 'chicv',
  [zolucky]: 'chicv',
  [loop]: loop,
  [jeulia]: jeulia,
  [ruelala]: 'rue',
  [gilt]: 'rue',
  [sifubuy]: sifubuy,
  [royaura]: 'dehan',
  [zeelool]: zeelool,
  [vooglam]: zeelool,
  [dressin]: 'sailvan',
  marshydro: 'mars-hydro', // 如果platform和channel不一致，后续需要添加channel，因为signature时候，没有channel查不到信息
};

// 用于登录入参 根据platform作映射 有些channel会和subpath不一致，新增平台不一致时需要在这里配置
export const CHANNEL_MAP = {
  shopsimon: 'shoppremiumoutlets',
  [competitivecyclist]: backcountry,
  [steepandcheap]: backcountry,
  [motosports]: backcountry,
  [levelninesports]: backcountry,
  [stylewe]: 'chicv',
  [fehaute]: 'chicv',
  [hardaddy]: 'chicv',
  [justfashionnow]: 'chicv',
  [noracora]: 'chicv',
  [zolucky]: 'chicv',
  [royaura]: 'dehan',
  [dressin]: 'sailvan',
};

// RA 险种类型  用于判断是否为ra  后续可直接添加，当险种仅为ra时配置
export const RAPolicyType = ['RA', 'GENTLY_RA', 'TREET_RA', 'GARMENTORY_RA', 'SIDELINESWAP_RA', 'GOODWILLFINDS_RA', 'SHOPPREMIUMOUTLETS_RA', 'CURTSY-RA', 'SHOPSHOPS-RA', 'CTBIDS-RA', 'LDJ-RA'];

// 平台没有邮箱，只通过orderNumber登录，所以需要特殊逻辑跳过登录，后续可直接添加平台
export const NO_EMAIL_CHANNEL = [DHGATE, SHOPLAZZA, dhgate];

// special merchants display custumization logo(2022081920364456079055 is for test) https://seel.atlassian.net/browse/OP-2938
export const realAuthenticationMerchantID = ['2023090820837673816777', '2023091420016583407178', '2023091520688755454467'];

// 接口提交时根据platform换回policyType  没映射成功的可不传 接口自动判断返回
export const platformToPolicyTypeMap = {
  [GENTLY]: 'GENTLY_RA',
  [TREET]: 'TREET_RA',
};

// 只展示own carrier的店铺  2024031820209350224350-84feb0-2.myshopify.com
// export const ONLY_SUPPORTED_OWN_CARRIER = ['2024031820209350224350'];
// 只展示own carrier的平台，这里为了方便平台接入考虑。当然也可以配置在ONLY_SUPPORTED_OWN_CARRIER中，用merchantID判断
// export const ONLY_OWN_CARRIER_BASE_PLATFORM = [CTBIDS];
// 弹窗展示尺寸信息的店铺。目前只有GBG（2023092820637391214366） & GWF（2023102420507030369331） 需要计算动态运费  test #1047 2022081620353595329444 merchantId & 2024031820209350224350-84feb0-2.myshopify.com  & 2024073020177570720034 for test
export const SHOW_PACKAGE_DIMENSION = ['2023092820637391214366', '2023102420507030369331', '2022081620353595329444', '2024031820209350224350'];
export const SHOW_PACKAGE_DIMENSION_BY_PLATFORM = [GOODWILLFINDS, LDJ];
// 只有指定平台才能补充trackingNumber，后续可直接配置
export const NEED_TO_ADD_TRACKING_NUMBER = [SHOPLINE, CTBIDS];
// 根据policy type转换成specialplatform 用于支持无tracking number 场景 暂时只支持gsp 无ra场景
export const policyTypeToSpecialPlatformMap = {
  'SHOPLINE-GSP': SHOPLINE,
  'CTBIDS-GSP': CTBIDS,
  'CTBIDS-RA': CTBIDS,

};
// 支持用signature登录的平台，后续可以直接配置
export const SUPPORT_SIGNATURE_TO_LOGIN = [SHOPSHOPS, COMMENTSOLD];

/* **************************************************************新平台config end ***************************************************************************** */

// 动态配置 用于app.js匹配platform 匹配则存储platform 类似/(treet|garmentory|poizon|gently)/
export const PLATFORM_REG = new RegExp(Object.values(PLATFORM_NAME).join('|'));
// 动态配置 用于route/navigate 页面  类似['/', '/treet', '/garmentory', '/poizon', '/gently']
export const ROUTE_ARR = ['/', ...Object.values(PLATFORM_NAME).map((item) => `/${item}`)];

/** 支付方式 */
export const PaidMethod = {
  Tremendous: 'tremendous',
};

/** 邮箱地址 */
export const EmailAddress = {
  Seel: 'support@seel.com',
  Garmentory_support: 'support@garmentory.com',
  Poizon_support: 'support@poizon.us',
};

/** 允许上传文件的最大大小（单位：MB） */
export const MAX_UPLOAD_FILE_SIZE = 20;
/** 允许上传文件的最大数量 */
export const MAX_UPLOAD_FILE_NUM = 10;
/** 允许上传文件的类型 */
export const ALLOWED_UPLOAD_TYPE = ['.jpg', '.jpeg', '.png', '.tif', '.tiff', '.ico', '.bmp', '.webp', '.gif', '.zip'];

/** deliver 状态 */
export const ShipmentStatus = {
  Delivered: 'delivered',
  UnDelivered: 'un_delivered',
  unDelivered: 'undelivered',
  Unknown: 'unknown',
  Pending: 'pending',
};
// 首页手机号验证正则
export const regPhoneLogin = /^\+?(\d{1,3})?\d{9,12}$/;
// 首页email验证正则
export const regEmail = /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
/** email输入框状态 */
export const InputStatus = {
  /** 初始化 */
  Init: 0,
  /** 修改过 */
  Changed: 1,
};

// review页面 是否勾选bp insurance的金额临界值 >=50 默认勾选
export const TOTAL_MONEY_LIMIT_FOR_CHECKED = 50;

// return-method $300以上只有seel label OP-2805
// export const MAX_MONEY_LIMIT_FOR_RETURN_METHOD = 300;

export const SHIPPING_CARRIER = [{
  value: 'USPS',
  label: 'USPS',
}, {
  value: 'UPS',
  label: 'UPS',
}, {
  value: 'FedEx',
  label: 'FedEx',
}, {
  value: 'DHL Express',
  label: 'DHL Express',
}, {
  value: 'GLS',
  label: 'GLS',
}, {
  value: 'Others',
  label: 'Others',
},
];
